import { createSelector } from '@ngrx/store';

import { modalsState } from '../root';

export const isModalTypeOpen = (type: OLO.Components.Modals.MODAL_TYPE) => createSelector(
    modalsState,
    modals => modals.some(modal => modal.type === type)
);
